import React, { useState, useEffect, useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import GridItem from 'components/Grid/GridItem';
import { wsGet } from 'services/WService';
import { nDecimal } from 'hooks/Pipe';
import moment from 'moment';

function PurchaseDocumentModal(props) {
  const document = props.model;

  const [paymentTerms, setPaymentTerms] = useState([]);
  const [DueDate, setDueDate] = useState(
    moment(document.PchDocDueDate || document.DocDueDate).format('YYYY-MM-DD'),
  );

  const title = useMemo(() => {
    if (document.id === undefined) return 'Documento';
    return `Documento ${document.ReceiptSerie}-${document.ReceiptNumber.padStart(8, '0')}`;
  }, [document]);

  useEffect(() => {
    if (paymentTerms.length === 0) {
      wsGet('base/payment-term')
        .then((res) => setPaymentTerms(res.data))
        .catch((ex) => props.showNotify(ex.res.data.message));
    }
  }, []);

  useEffect(() => {
    setDueDate(moment(document.PchDocDueDate || document.DocDueDate).format('YYYY-MM-DD'));
  }, [document]);

  return (
    <Modal
      title={title}
      model={document}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="purch/purchase-document"
    >
      <GridContainer>
        <GridItem xs={6}>
          <h6>Total documento</h6>
          <h5>{nDecimal(document.DocTotal)}</h5>
        </GridItem>
        <GridItem xs={3}>
          <h6>Zona</h6>
          <h5>{document.base_zone_code}</h5>
        </GridItem>
        <GridItem xs={3}>
          <h6>Almacén</h6>
          <h5>{document.WhsCode}</h5>
        </GridItem>
      </GridContainer>

      <TextField
        label="Fecha documento"
        type="date"
        name="PchTaxDate"
        margin="normal"
        fullWidth
        defaultValue={moment(document.PchTaxDate || document.tax_date).format('YYYY-MM-DD') || ''}
        inputProps={{
          max: DueDate,
        }}
        required
      />

      <TextField
        label="Fecha contabilización"
        type="date"
        name="PchDocDate"
        margin="normal"
        fullWidth
        defaultValue={moment(document.PchDocDate || document.DocDate).format('YYYY-MM-DD') || ''}
        required
      />
      <TextField
        label="Fecha vencimiento"
        type="date"
        name="PchDocDueDate"
        margin="normal"
        fullWidth
        defaultValue={
          moment(document.PchDocDueDate || document.DocDueDate).format('YYYY-MM-DD') || ''
        }
        onChange={(e) => {
          setDueDate(e.target.value);
        }}
        required
      />

      <FormControl fullWidth margin="normal" required>
        <InputLabel>Término de pago</InputLabel>
        <Select
          defaultValue={document.PchGroupNum || document.GroupNum || ''}
          inputProps={{
            name: 'PchGroupNum',
          }}
        >
          {paymentTerms.map((paymentTerm, i) => {
            return (
              <MenuItem value={paymentTerm.GroupNum} key={i}>
                {paymentTerm.PymntGroup}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Modal>
  );
}

export default PurchaseDocumentModal;
